const PIREPIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2521_83594)">
        <circle
          cx="12"
          cy="12"
          r="11.5"
          fill="#93E9BE"
          fillOpacity="0.3"
          stroke="#93E9BE"
        />
        <path
          d="M6 9.58571C6 8.50561 6 7.96556 6.2102 7.55302C6.3951 7.19013 6.69013 6.8951 7.05302 6.7102C7.46556 6.5 8.00561 6.5 9.08571 6.5H14.4857C15.5658 6.5 16.1059 6.5 16.5184 6.7102C16.8813 6.8951 17.1763 7.19013 17.3612 7.55302C17.5714 7.96556 17.5714 8.50561 17.5714 9.58571V13.25C17.5714 14.1486 17.5714 14.5979 17.4246 14.9523C17.2289 15.4249 16.8534 15.8003 16.3809 15.9961C16.0265 16.1429 15.5772 16.1429 14.6786 16.1429C14.3645 16.1429 14.2074 16.1429 14.0617 16.1773C13.8675 16.2231 13.6866 16.3136 13.5333 16.4415C13.4184 16.5374 13.3242 16.663 13.1357 16.9143L12.1971 18.1657C12.0576 18.3518 11.9878 18.4449 11.9022 18.4781C11.8273 18.5073 11.7441 18.5073 11.6692 18.4781C11.5837 18.4449 11.5139 18.3518 11.3743 18.1657L10.4357 16.9143C10.2473 16.663 10.153 16.5374 10.0381 16.4415C9.88486 16.3136 9.70394 16.2231 9.50968 16.1773C9.36399 16.1429 9.20694 16.1429 8.89286 16.1429C7.99426 16.1429 7.54495 16.1429 7.19054 15.9961C6.71798 15.8003 6.34254 15.4249 6.1468 14.9523C6 14.5979 6 14.1486 6 13.25V9.58571Z"
          fill="#93E9BE"
        />
        <path
          d="M11.7857 11.3214V9.07143M11.7857 13.5714H11.7921M10.4357 16.9143L11.3743 18.1657C11.5139 18.3518 11.5837 18.4449 11.6692 18.4781C11.7441 18.5073 11.8273 18.5073 11.9022 18.4781C11.9878 18.4449 12.0576 18.3518 12.1971 18.1657L13.1357 16.9143C13.3242 16.663 13.4184 16.5374 13.5333 16.4415C13.6866 16.3136 13.8675 16.2231 14.0617 16.1773C14.2074 16.1429 14.3645 16.1429 14.6786 16.1429C15.5772 16.1429 16.0265 16.1429 16.3809 15.9961C16.8534 15.8003 17.2289 15.4249 17.4246 14.9523C17.5714 14.5979 17.5714 14.1486 17.5714 13.25V9.58571C17.5714 8.50561 17.5714 7.96556 17.3612 7.55302C17.1763 7.19013 16.8813 6.8951 16.5184 6.7102C16.1059 6.5 15.5658 6.5 14.4857 6.5H9.08571C8.00561 6.5 7.46556 6.5 7.05302 6.7102C6.69013 6.8951 6.3951 7.19013 6.2102 7.55302C6 7.96556 6 8.50561 6 9.58571V13.25C6 14.1486 6 14.5979 6.1468 14.9523C6.34254 15.4249 6.71798 15.8003 7.19054 15.9961C7.54495 16.1429 7.99426 16.1429 8.89286 16.1429C9.20694 16.1429 9.36399 16.1429 9.50968 16.1773C9.70394 16.2231 9.88486 16.3136 10.0381 16.4415C10.153 16.5374 10.2473 16.663 10.4357 16.9143Z"
          stroke="#272727"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2521_83594">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PIREPIcon;
